import { render, staticRenderFns } from "./nameTabs.vue?vue&type=template&id=8e2f624a"
import script from "./nameTabs.vue?vue&type=script&lang=js"
export * from "./nameTabs.vue?vue&type=script&lang=js"
import style0 from "./nameTabs.vue?vue&type=style&index=0&id=8e2f624a&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports